// @flow

export const filtersType = {
    BUILD_YOUR_OWN: 'BUILD_YOUR_OWN',
    BY_CATEGORY: 'BY_CATEGORY',
    BY_DEVICE: 'BY_DEVICE',
    SHOW_ALL: 'SHOW_ALL',
    WELCOME_HOME: 'WELCOME_HOME'
};



// WEBPACK FOOTER //
// ./src/components/widgets/actions/constants.js